module.exports = __webpack_public_path__ + "feedback.3a03c78e.png";